<template>
  <div>
    <donut-page-title title="My History" />
    <donut-tabs
      :tabs="tabs"
      :initial-tab="tabs.find(tab => tab.value === initialTabValue)"
      :can-select-tabs="false"
      class="m-tx4"
    />
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { initialTabValue } = defineProps({
    initialTabValue: { type: String, required: true },
  });
  const { state } = useStore();

  const tabs = computed(() => {
    const fullList = [
      { title: 'My Intro History', value: 'history', link: '/coffee/dashboard' },
      { title: 'My Intro Stats', value: 'stats', link: '/coffee/dashboard/stats' },
    ];
    if (state.rewardsProgram.program?.state === 'active') fullList.unshift({ title: 'My Rewards', value: 'rewards', link: '/rewards/redemptions/history' });
    return fullList;
  });
</script>
